export const environment = {
  production: true,
  maintenanceMode: false,
  appCode: 'inventory-report',
  // デバッグモード（本番環境では無効）
  debug: false,
  /** Garage 在庫報告／納品計画API */
  inventoryApiUrl: '//api.out.inventory-report.p-garage.jp/api',
  inventoryTaskApiUrl: 'https://task.out.inventory-report.p-garage.jp/api',
  inventoryBackendApiUrl:
    'https://backend.out.inventory-report.p-garage.jp/api',
  /** SORS用途別引当数 UI */
  inventorySorsUiUrl: 'https://sors.shimamura-api.com/inventory-reservation/',
  /** 共通バックエンドAPI */
  applicationActuateMacroApiUrl:
    '//backend-applicationactuatemacroapi.backend.out.green.ebisudebeer.com/api',
  /** バックエンドマクロAPI */
  backendMacroApiUrl:
    '//backend-macroapi.backend.out.green.ebisudebeer.com/api',
  /** 貿易部GarageAPI */
  smTradeGarageApiUrl: '//garage-oapi.sm-trade.garage.out.ebisudebeer.com',
  /** Garageバックエンド(IsBiz) API */
  garageBackendApiUrl: '//isbiz-oapi.garage.out.ebisudebeer.com',
  /** Garage Filebox API */
  garageFileboxApiUrl: '//filebox.oapi.garage.out.ebisudebeer.com',
  /** My-idea UI */
  myIdeaUiUrl: '//my-idea.idea-place.jp/',
  // 本番では利用しない。
  indexCoreApiUrl: '',
  /** ProSche入力補助UI */
  proScheInputAssistanceUiUrl: 'https://group-list-editor.p-garage.jp',
  proScheInspectionAppUiUrl: 'https://group-list-editor.p-garage.jp',
};
